// extracted by mini-css-extract-plugin
module.exports = {"read-surah":"styles_read-surah__pOCdn"};